import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";
import Products from "./views/Products";
import ProductCategories from "./views/ProductCategories";
import Categories from "./views/Categories";
import PriceIncreases from "./views/PriceIncreases";
import Costs from "./views/Costs";
import { useTranslation } from 'react-i18next';
import TabView3 from "../../../../components/theme/TabView3/TabView3";
import { warehouseFinancialInvoiceComponentsConfig } from "./warehouseFinancialInvoiceComponentsConfig";
import { UserPrivileges } from "../../../../utils/permissions";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUserPermission } from "../../../../newapi/user/authentication/authSlice";
import { useTopbar } from "../../../../contexts/TopbarProvider";

const FinancialInvoiceComponents = () => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const {showExtraTitle,clearExtraTitle } = useTopbar();
  
    const hasPriceIncreasePermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.PRICEINCREASE_READ, UserPrivileges.PRICEINCREASE_MANAGE])
    );

    const hasInvoiceCategoryPermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.INVOICECATEGORY_MANAGE,UserPrivileges.INVOICECATEGORY_READ])
    );

    const hasInvoiceCostPermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.COST_MANAGE,UserPrivileges.COST_READ])
    );

    const hasInvoiceProductCategoryPermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.INVOICEPRODUCT_MANAGE,UserPrivileges.INVOICEPRODUCT_READ])
    );

    const [tabConfig,setTabConfig] = useState(warehouseFinancialInvoiceComponentsConfig(hasPriceIncreasePermission,hasInvoiceCategoryPermission,hasInvoiceCostPermission,hasInvoiceProductCategoryPermission));

    useEffect(() => {
        setTabConfig(warehouseFinancialInvoiceComponentsConfig(hasPriceIncreasePermission,hasInvoiceCategoryPermission,hasInvoiceCostPermission,hasInvoiceProductCategoryPermission));
    },[hasPriceIncreasePermission,hasInvoiceCategoryPermission, hasInvoiceCostPermission, hasInvoiceProductCategoryPermission]);

    useEffect(() => {
        showExtraTitle(t("components"))

        return () => {
            clearExtraTitle();
        };
    }, [showExtraTitle,clearExtraTitle,t,i18n.language])

    return (
        <Box sx={{background:"", width:1,paddingTop:9}}>
            {ready ?
            <>
                <TabView3
                    tabConfig={tabConfig}
                    // ref={ref}
                    sx={{
                        background:"green",
                        minHeight:"calc(100% - 190px)",
                        background: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        position:"relative",
                        zIndex:2,
                        display:"flex",
                        flexDirection:"column",

                        "&:before" : {
                            content: "''",
                            display:"block",
                            width:"32px",
                            height:"32px",
                            position:"absolute",
                            left:0,
                            top:0,
                            zIndex:1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                            top:"40px",
                            height:"48px",
                            width:"24px",
                            borderTopLeftRadius:"24px",
                            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                            transition:"250ms"
                        },

                        "&:after" : {
                            content: "''",
                            display:"block",
                            width:"32px",
                            height:"32px",
                            position:"absolute",
                            top:0,
                            zIndex:1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                            top:"40px",
                            right:0,
                            height:"48px",
                            width:"24px",
                            borderTopLeftRadius:"24px",
                            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                            transform:"scaleX(-1)",
                            transition:"250ms"
                        },

                        "@media screen and (max-width: 47.9375em)" : {
                            "&:after, &:before" : {
                                top:"-0px"
                            }
                        }
                    }}
                >
                    <>
                        <Products config={warehouseFinancialInvoiceComponentsConfig.products}/>
                        {hasInvoiceProductCategoryPermission &&
                            <ProductCategories config={tabConfig.productCategories}/>
                        }
                        {hasInvoiceCostPermission &&
                            <Costs config={tabConfig.costs}/>
                        }
                        {hasInvoiceCategoryPermission &&
                            <Categories config={tabConfig.categories}/>
                        }
                        {hasPriceIncreasePermission &&
                            <PriceIncreases config={tabConfig.priceIncreases}/>
                        }
                    </>
                </TabView3>
                {/* </TabView> */}
            </>
            :null}
        </Box>
    );
};

export default FinancialInvoiceComponents;